export default class NewsletterForm {

    constructor(element = null) {
        this.element = element;
        this.config = JSON.parse(this.element.dataset.newsletterForm);

        // We have seen a large number of spam submissions by simple bots.
        // An easy fix is to set the url and display the banner via JavaScript
        // as many simple bots do not execute JavaScript.
        this.element.action = this.config.url;
    }

}
